import { useTranslation } from 'react-i18next';
import { ChangeEvent, useContext } from 'react';
import { Flex, Form, FormContext } from 'dash-ui';

import { FormFields } from 'containers/properties/PropertyGeneralInformation/components/PropertyGeneralInfoForm/constants/constants';

const CommissionInput = ({ saleTeamIndex }: { saleTeamIndex: number }) => {
  const { t } = useTranslation(['forms', 'common', 'pages']);
  const { formState, formErrors, stateHandlers } = useContext(FormContext);

  const { saleTeamId, commission = undefined } =
    formState[FormFields.SaleTeams][saleTeamIndex] || {};

  const onChange = (e: ChangeEvent<HTMLInputElement>) => {
    const saleTeams = [...formState[FormFields.SaleTeams]];

    saleTeams[saleTeamIndex] = {
      ...saleTeams[saleTeamIndex],
      commission: Number(e.target.value || 0),
    };

    stateHandlers[FormFields.SaleTeams](saleTeams);
  };

  return (
    <Flex flex={1} flexDirection="column" mr={2}>
      <Form.Label>{t('forms:labels.commission')}</Form.Label>
      <Form.Input
        w="100%"
        type="number"
        value={commission || ''}
        placeholder={t('forms:placeholders.commission') || ''}
        onChange={onChange}
        $errorType={
          formErrors[FormFields.SaleTeams]?.[saleTeamIndex]?.commission?.type
        }
        disabled={!saleTeamId}
      />
      <Form.Feedback
        $errorType={
          formErrors[FormFields.SaleTeams]?.[saleTeamIndex]?.commission?.type
        }
      >
        {formErrors[FormFields.SaleTeams]?.[saleTeamIndex]?.commission?.message}
      </Form.Feedback>
    </Flex>
  );
};

export default CommissionInput;
